import React from 'react';
import * as Style from './IconInfoCircle.style';

const IconInfoCircle = ({
  color = '#74C1FF',
  testId = 'icon-info-circle',
  size = '20',
}) => (
  <Style.Wrapper data-testid={testId}>
    <svg xmlns="http:// www.w3.org/2000/svg" width={size} fill="none" height={size} viewBox="0 0 21 20">
      <path d="M10.4998 13.3333V9.99996M10.4998 6.66663H10.5082M18.8332 9.99996C18.8332 14.6023 15.1022 18.3333 10.4998 18.3333C5.89746 18.3333 2.1665 14.6023 2.1665 9.99996C2.1665 5.39758 5.89746 1.66663 10.4998 1.66663C15.1022 1.66663 18.8332 5.39758 18.8332 9.99996Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Style.Wrapper>
);


export default IconInfoCircle;
